import { render, staticRenderFns } from "./ZoneDosageTableContainer.vue?vue&type=template&id=492ed474&"
import script from "./ZoneDosageTableContainer.vue?vue&type=script&lang=ts&"
export * from "./ZoneDosageTableContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports